import ShimmerContentBlock from "./ContentBlock";

export default ShimmerContentBlock;
